var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("div", { staticClass: "relative" }, [
        _c("input", {
          staticClass: "m0 no-outline",
          attrs: { type: "checkbox", id: _vm.id, disabled: _vm.disabled },
          domProps: { checked: _vm.value },
          on: {
            keyup: function($event) {
              if (
                !$event.type.indexOf("key") &&
                _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
              ) {
                return null
              }
              return _vm.$emit("click")
            },
            click: function($event) {
              return _vm.$emit("click")
            },
            blur: function($event) {
              return _vm.$emit("blur")
            },
            change: function($event) {
              return _vm.$emit("change", $event.target.checked)
            }
          }
        }),
        _vm._v(" "),
        _c(
          "label",
          { staticClass: "pl35 lh30 h4 pointer", attrs: { for: _vm.id } },
          [_vm._t("default")],
          2
        )
      ]),
      _vm._v(" "),
      _vm.validations
        ? _c("ValidationMessages", { attrs: { validations: _vm.validations } })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }